export default __webpack_public_path__ + "static/media/ipg.0c0cdbe8.jpg";